import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kw-banner-wrapper',
  templateUrl: './banner-wrapper.component.html',
  styleUrls: ['./banner-wrapper.component.scss']
})
export class BannerWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
